var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import '@styles/webdesktop/stylesheets/contextMenuItemActions.scss';
import { forwardRef } from 'react';
import { SvgIcon } from '../../SvgIcon/SvgIcon';
import { Typography } from '../../Typography/Typography';
import { TypographyLevel } from '../../Typography/TypographyLevel';
import { Spacing } from '@front/sharedcomponents/Variables';
import { Stack } from '@front/sharedcomponents/Stack/Stack';
import { TooltipDecorator } from '../../Tooltip/TooltipDecorator';
import { Background, BorderSize, Foreground } from '@front/sharedcomponents/Styles';
export const ContextMenuItemActions = forwardRef((_a, ref) => {
    var { text, actions, checked = false, onClick } = _a, restProps = __rest(_a, ["text", "actions", "checked", "onClick"]);
    const handleMainClick = () => {
        onClick === null || onClick === void 0 ? void 0 : onClick();
    };
    const handleMainKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleMainClick();
        }
    };
    const handleActionKeyDown = (e, action) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            action.onClick();
        }
    };
    const groupClassNames = [
        'context-menu-item-actions',
        checked ? Background.Primary : Background.Secondary,
        checked ? Foreground.Primary : Foreground.Secondary,
        BorderSize.None
    ];
    const groupClassName = groupClassNames.filter(Boolean).join(' ');
    return (_jsx("li", Object.assign({ role: "none", ref: ref }, restProps, { children: _jsxs("fieldset", { "aria-label": text, className: groupClassName, children: [_jsx("div", { role: "menuitem", className: "context-menu-item-actions-text", tabIndex: 0, onClick: handleMainClick, onKeyDown: handleMainKeyDown, children: _jsx(Typography, { level: TypographyLevel.BodyMd, noWrap: true, children: text }) }), _jsx(Stack, { className: "context-menu-item-actions-container", direction: "row", justify: "flex-end", align: "center", spacing: Spacing.M, children: actions.map((action) => (_jsx(TooltipDecorator, { content: action.title, children: _jsx("div", { role: "menuitem", className: "context-menu-item-actions-container-action", tabIndex: 0, onClick: () => {
                                action.onClick();
                            }, onKeyDown: (e) => {
                                handleActionKeyDown(e, action);
                            }, "aria-label": action.title, children: _jsx(SvgIcon, { icon: action.icon }) }) }, action.id))) })] }) })));
});
